export default __webpack_public_path__ + "static/iam_policy_01-d590f22e084a613ce1fb634a57e135bb.png";